import { forwardRef, type InputHTMLAttributes } from "react";
import styles from "./input.module.scss";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  inputSize?: "sm" | "md" | "lg";
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ inputSize = "md", error, className, ...props }, ref) => {
    const cls = [
      styles.input,
      styles[inputSize],
      error ? styles.error : "",
      className ?? "",
    ].filter(Boolean).join(" ");

    return <input ref={ref} className={cls} {...props} />;
  },
);

Input.displayName = "Input";
